import React, {useState} from 'react';
import './App.css';
import OrderCard from './components/ordercard'
import NewOrder from './components/neworder'
import {Grid, Typography, Box} from '@material-ui/core'

const io = require('socket.io-client')
const socket = io('https://bigsmokebrew.herokuapp.com') //If connecting to deployed server on Heroku
//const socket = io('http://localhost:3002')
var count = 0
var updateCount = 0
var renderCount = 0
function App() {

  const [orders, setOrders] = useState([]);
 
  
  socket.once("neworders", latest_orders =>{
    setOrders(latest_orders)
    count +=1
    console.log("ORDERS!!",count, socket.id)
    
    //console.log("socket neworders")
    //var shouldUpdate = !(JSON.stringify(latest_orders) === JSON.stringify(orders))
    //if (shouldUpdate) {
     // updateCount +=1
      
     //console.log("ORDERS DONT MATCH!",updateCount )
      //setOrders(latest_orders)
          
    })
  
  function removeOrder(order_number){
    //Need to some how call this function on parent component 
    socket.emit("remove",order_number)
  }
 
  const addNewOrder = (description) =>{
    //Need to somehow call this on parent component
    socket.emit("add_new_order",description);
}
  renderCount +=1
  console.log("Rendering", renderCount)

  return (
    <div className="App">
      <Typography  align="center" color = "secondary" gutterBottom = "true" variant="h5">The Old Wheatsheaf</Typography>
        <NewOrder addNewOrder={addNewOrder}></NewOrder>
      <Grid container spacing = {4}>
        {orders.map(order =>(<OrderCard removeOrder = {removeOrder} key = {order.order_number} order_number = {order.order_number} ready_time={order.display_time} order_status = {order.status} description = {order.description  } >SOME TEXT</OrderCard>))   }
        </Grid>
    </div>
  );
}
 
export default App;


